import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
export default action('changeFrom')(function changeFrom(viewState, sendAsAddress) {
    var userConfig = getUserConfiguration();
    if (viewState.from.email != sendAsAddress) {
        viewState.from = {
            email: {
                MailboxType: 'Mailbox',
                RoutingType: 'SMTP',
                EmailAddress: sendAsAddress,
                Name: userConfig.SessionSettings.UserDisplayName,
            },
        };
    }
});
//# sourceMappingURL=changeFrom.js.map